import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { theme } from '@/theme';

export const Wrapper = styled(Flex)`
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(5)};
`;

export const Container = styled(Box)<{
  $isFromFaqWrapCategories: boolean;
}>`
  ${({ $isFromFaqWrapCategories, theme }) =>
    $isFromFaqWrapCategories
      ? css`
          width: 100%;
          ${theme.media.md.down} {
            margin-left: ${theme.spacing(0)};
            margin-right: ${theme.spacing(0)};
          }
        `
      : css`
          width: 800px;
          ${theme.media.md.down} {
            width: 100%;
            padding-left: ${theme.spacing(2)};
            padding-right: ${theme.spacing(2)};
          }
        `}
`;
export const MoreResultsBox = styled(Box)`
  ${({ theme }) => css`
    color: ${theme.colors.primaryDark};
    font-size: ${theme.fontSizes.p2};
    padding: ${theme.spacing(3)};
  `}
  display: flex;
  justify-content: center;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: 700;
`;
export const StyledIcon = styled(Icon)`
  transform: translateY(${theme.spacing(0.65)});
  margin-left: ${theme.spacing(0.5)};
`;
